import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';

import {
  BoothAuthority,
  BoothData,
  MuseumTicketData,
} from '../interfaces/museum';

const findTicketByBooth = (
  tickets?: MuseumTicketData[],
  boothId?: string,
): MuseumTicketData | undefined => {
  if (_isEmpty(tickets) || !boothId) {
    return undefined;
  }

  return _find(tickets, (ticket) => {
    const { museumBooths } = ticket;
    return !!_find(museumBooths, ['datoId', boothId]);
  });
};

const hasAccessBoothById = (
  boothId?: number,
  boothAuthority?: BoothAuthority,
): boolean => {
  if (!boothId) {
    return false;
  }

  return boothAuthority ? boothAuthority[boothId] : false;
};

const hasAccessBooth = (
  booth?: BoothData,
  boothAuthority?: BoothAuthority,
): boolean => {
  if (!booth) {
    return false;
  }

  return hasAccessBoothById(booth.id, boothAuthority);
};

export { findTicketByBooth, hasAccessBooth, hasAccessBoothById };
